<template>
    <div class="box-header box-header--collapsible-md">
        <div class="box-header__main-content"
            :class="{
                'box-header__menu--collapse': isMobileOpened
            }">
            <div class="box-header__heading box-header__menu-active">
                {{active && active.title}}
            </div>
            <ul class="box-header__menu  box-header__menu--light"
                :class="{
                    'box-header__menu-active': isMobileOpened
                }">
                <li class="box-header__menu-item"
                    style="cursor: pointer"
                    :key="item.id"
                    @click="() => onItemClick(item)"
                    v-for="item in items">
                    <span class="box-header__menu-link"
                        :class="{'active': active.id === item.id}">
                        <span class="item_icon"></span> {{item.title}}
                    </span>
                </li>
            </ul>
        </div>
        <div class="box-header__right-content">
            <div @click="isMobileOpened = !isMobileOpened"
                :title="buttonText"
                class="box-header__icon box-header__icon--collapsible icon-right-menu">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {},
        items: {},
        onClick: {},
        buttonText: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isMobileOpened: false
        }
    },
    methods: {
        onItemClick(item) {
            if (this.onClick) {
                this.onClick(item);
            }
            this.isMobileOpened = false;
        }
    }
}
</script>